import React from 'react';

import Authenticated from 'Components/Layouts/Authenticated';
import { Link } from 'react-router-dom';
import { asset } from 'Services/BaseHelpers';

export default function GettingReady() {
    const gettingReady = [
        // {
        //     image: '/images/settings/person-lock.svg',
        //     title: 'Testing',
        //     text: 'If you haven’t already done so, prior to the event going live, please log in to the event site using the email address and password you registered your attendance with. If you’ve forgotten your password please use the contact us page of the website to request a password reset.',
        // },
        {
            image: '/images/settings/loader.svg',
            title: 'Buffering on the event Stream',
            text: 'If the web stream buffers, this will be due to your local connectivity. Please be patient and refresh the page. If that doesn’t work you may wish to try tethering/hot spotting from your mobile (although this will use your mobile data and may incur charges depending on your phone agreement).',
        },
        {
            image: '/images/settings/eye.svg',
            title: 'Viewing Live Stream',
            text: 'Please visit the test stream page to check that you can view the event stream.',
        },
        {
            image: '/images/settings/support.svg',
            title: 'Event Support',
            text: () => (<>
                If you need any help with accessing the site or during the event, please contact Gina Normington or
                Natasha Cooke via Teams.
            </>),
        },
        {
            image: '/images/settings/speaker.svg',
            title: 'Hearing the event Stream',
            text: 'To manage the volume on the event stream hover over the middle of the event stream window, you will be able to see a volume bar in the bottom right corner of the stream. Please also check that your devices audio is turned up and unmuted. ',
        },
        {
            image: '/images/settings/tv.svg',
            title: 'Viewing on Smart TV',
            text: () => (<>
                For the full experience you can even watch the event through your smart TV web browser. Just type in the
                web address using your TV remote or plug in a USB keyboard to your TV. <Link
                to="/">{window.location.protocol + '//' + window.location.host}</Link>
            </>),
        },
    ]

    return (
        <React.Fragment>
            <div className="bg-app-blue bg-decals bg-no-repeat-y bg-repeat-x w-full -mt-4 p-8 lg:py-16">
                <div className="max-w-5xl w-full mx-auto text-white space-y-4">
                    <div className="font-aleo text-2xl">
                        Get Ready
                    </div>
                    <div>
                        As we continue to celebrate our success virtually, please take the following steps to ensure
                        you’re all set for the live event.
                    </div>

                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                        {gettingReady.map(({ image, title, text: Text }, k) => (
                            <div className="flex flex-row">
                                <div>
                                    <img className="w-10" alt="" src={asset(image)}/>
                                </div>

                                <div className="ml-4 w-full flex-1">
                                    <div className="font-aleo text-xl">
                                        {title}
                                    </div>

                                    <div>
                                        {typeof Text === 'string' && Text}
                                        {typeof Text === 'function' && <Text/>}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <div className="bg-primary bg-bottom bg-cover w-full -mt-4 p-8 lg:py-16">
                <div className="max-w-5xl w-full mx-auto flex flex-row space-x-12">
                    <div className="space-y-4">
                        <div>
                            <div className="font-aleo text-2xl">
                                Taking Part
                            </div>
                            <div>
                                You can interact with the event using emoji reactions, comments and uploading pictures.
                                This
                                can be done by using the controls on the event stream page. Emojis comments and pictures
                                will visible to all associates watching the event. Comments will be moderated so as
                                always
                                please be kind and bring only positive vibes to the party.
                            </div>
                        </div>

                        <div>
                            <div className="font-aleo text-2xl">
                                Remote Control
                            </div>
                            <div>
                                On the event stream page you will see a button to launch the remote control. This
                                feature
                                allows you to access the emojis, comments and photo upload from your mobile device. Use
                                the
                                camera of your phone to scan the QR code and when prompted, click the link to open your
                                web
                                browser. This will launch the remote control function from where you can react to the
                                event
                                with emojis and your congratulatory comments. You can also upload photos of you enjoying
                                the
                                evening, all from the comfort of your armchair and the convenience of your phone.
                            </div>
                        </div>
                    </div>

                    <div className="hidden lg:block h-full w-full">
                        <img src={asset('/images/settings/phone.png')} className="w-full"/>
                    </div>
                </div>
            </div>

            <div className="bg-white p-8 lg:py-16">
                <div className="max-w-5xl w-full mx-auto space-x-12 text-center text-app-blue">
                    <div>
                        <div className="font-aleo w-full text-2xl">
                            <img className="w-24 mx-auto" alt="" src={asset('/images/settings/technical.svg')}/><br/>
                            Technical
                        </div>

                        <div>
                            On the day of the event, to maximise your viewing experience, please take the following
                            steps:
                        </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-6">
                        <div>
                            <div className="text-2xl">1.</div>
                            View the stream on Firefox, Safari or Chrome browsers.
                        </div>
                        <div>
                            <div className="text-2xl">2.</div>
                            Plug the device you are streaming on directly into your router if possible.
                        </div>
                        <div>
                            <div className="text-2xl">3.</div>
                            Turn off all other software on your laptop, this includes webex, teams, chats, outlook,
                            google updates – the lot!
                        </div>
                        <div>
                            <div className="text-2xl">4.</div>
                            Politely ask residents in your home to minimise their use of internet where necessary
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}
